import { Star, Quote, Heart, Sparkles } from "lucide-react";

// TODO (Post-launch Jan 2027): Replace these with REAL parent testimonials
// Keep entries short (30-40 words max) for the marquee to feel snappy.
const parentQuotes = [
  { name: "Anjali & Rohit Sharma", child: "Vihaan, 4", city: "Jaipur", role: "Parent", quote: "Our son comes home singing shlokas and asking to help in the kitchen. Aadi Gayanam has given him roots we couldn't teach at home.", palette: "from-orange-500 to-red-500", monogram: "अ" },
  { name: "Priya Verma", child: "Aarohi, 3", city: "Malviya Nagar", role: "Mother", quote: "The moment I stepped into their trial class, I knew. This is not a school — it is a warm home where my daughter is truly seen.", palette: "from-rose-500 to-pink-600", monogram: "प्रि" },
  { name: "Dr. Sanjay Mishra", child: "Ishaan, 5", city: "Vaishali Nagar", role: "Father, Doctor", quote: "As a paediatrician, I evaluate schools clinically. Aadi Gayanam's balance of yoga, storytelling and modern pedagogy is honestly world-class.", palette: "from-emerald-500 to-teal-600", monogram: "सं" },
  { name: "Meera Iyer", child: "Kavya, 2.5", city: "Bani Park", role: "Mother", quote: "The teachers greet my child by name, know her mood every morning, and celebrate every tiny milestone. This is what love looks like in a classroom.", palette: "from-fuchsia-500 to-purple-600", monogram: "मी" },
  { name: "Kunal & Ritika Gupta", child: "Arya, 4", city: "Mansarovar", role: "Parents", quote: "We wanted our child to grow up proud of being Bharatiya. Aadi Gayanam has made that possible — festivals, stories, values — all with joy.", palette: "from-amber-500 to-orange-600", monogram: "कु" },
  { name: "Divya Agarwal", child: "Vivaan, 3.5", city: "C-Scheme", role: "Mother, Founder-CA", quote: "I run a business. I don't have hours to google curriculum. Aadi Gayanam took that off my plate — my son is thriving, socially and academically.", palette: "from-sky-500 to-blue-600", monogram: "दि" },
  { name: "Rakesh Sinha", child: "Aadya, 5", city: "Jagatpura", role: "Father", quote: "My daughter now folds her hands and says 'namaste' to elders unprompted. That single change is worth every rupee of the tuition.", palette: "from-red-500 to-orange-600", monogram: "रा" },
  { name: "Shweta Kaushik", child: "Krish, 4.5", city: "Tonk Road", role: "Working Mother", quote: "The regular updates, photos and gentle newsletters make me feel present in his day even when I am at office. Priceless peace of mind.", palette: "from-yellow-500 to-orange-500", monogram: "श्वे" }
];

// Duplicate the list so the marquee loops seamlessly
const marqueeList = [...parentQuotes, ...parentQuotes];

const ParentSayTicker = () => (
  <section className="py-16 bg-gradient-to-b from-amber-50 via-white to-orange-50 relative overflow-hidden" data-testid="parent-say-ticker">
    <div className="absolute inset-0 opacity-10 pointer-events-none">
      <div className="absolute top-10 -left-10 w-60 h-60 border-2 border-orange-400 rounded-full" />
      <div className="absolute bottom-10 -right-10 w-72 h-72 border-2 border-amber-400 rounded-full" />
    </div>

    <div className="container mx-auto px-4 mb-8 relative z-10">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-3">
          <Heart className="w-4 h-4 text-orange-600 fill-orange-500" />
          <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Parents Say</span>
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">
          Words That Warm Our Hearts
        </h2>
        <p className="text-stone-600 text-sm md:text-base">
          Real voices from the families we serve. Every quote is a little seed of trust we work hard to earn — every single day.
        </p>
      </div>
    </div>

    {/* Marquee row */}
    <div className="relative">
      {/* fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-amber-50 to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-orange-50 to-transparent z-10 pointer-events-none" />

      <div className="flex gap-5 animate-marquee-slow group hover:[animation-play-state:paused]" data-testid="parent-marquee">
        {marqueeList.map((p, i) => (
          <article
            key={`${p.name}-${i}`}
            className="flex-shrink-0 w-80 md:w-96 p-5 rounded-3xl bg-white border border-orange-100 shadow-md hover:shadow-2xl transition-all"
            data-testid={`parent-quote-${i}`}
          >
            <div className="flex items-center gap-3 mb-3">
              <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${p.palette} flex items-center justify-center shadow`}>
                <span className="font-devanagari text-xl font-bold text-white">{p.monogram}</span>
              </div>
              <div className="min-w-0">
                <p className="font-display font-bold text-stone-800 text-sm leading-tight truncate">{p.name}</p>
                <p className="text-[10px] text-stone-500 uppercase tracking-wider">
                  {p.role} • {p.city}
                </p>
              </div>
              <div className="ml-auto flex items-center gap-0.5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-3 h-3 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
            </div>
            <Quote className="w-5 h-5 text-orange-300 mb-1" />
            <p className="text-sm text-stone-700 leading-relaxed line-clamp-5">
              "{p.quote}"
            </p>
            <p className="mt-3 text-[10px] text-orange-700 font-bold uppercase tracking-widest">
              Parent of {p.child}
            </p>
          </article>
        ))}
      </div>
    </div>

    <div className="container mx-auto px-4 mt-6 text-center">
      <p className="text-[11px] text-stone-500 italic max-w-2xl mx-auto">
        <Sparkles className="w-3 h-3 inline text-orange-500 mr-1" />
        Hover to pause. Testimonials will be updated with real Jaipur families after our January 2027 launch.
      </p>
    </div>
  </section>
);

export default ParentSayTicker;
